{
  "greetings": "Saludos rebels",
  "TellUs": "Cuéntanos un poco sobre ti",
  "WhatCity": "¿En qué ciudad vives?",
  "aboutRebelBase": "RebelBase nació y se crió en la ciudad de Nueva York",
  "SearchCity": "Busca tu ciudad aquí",
  "purpose": "¿Cuál es tu propósito?",
  "ReadyButton": "¡LISTO!",

  "WayFindTitle": "Elige tu propia aventura",
  "WayFindPhrase": "¿Estás listo para tomar el control de esa gran idea que tienes? Pon en marcha tu proyecto con módulos paso a paso que te ayudarán a mejorar tus habilidades y a escalar a tu proyecto.",
  "CreateProject": "Crea un proyecto.",
  "WayFindPhrase2": "¿Tu equipo ya está en RebelBase? Pídeles que te inviten al proyecto .",
  "WayFindPhrase3": "La Base es un lugar complejo: explora todos los proyectos, empresas e innovaciones se están construyendo y son apoyadas por Rebels, como tú.",
  "BrowseProjects": "Explorar proyectos.",
  "WayFindPhrase4": "¿Necesitas un espacio para colaborar, conectar y competir? Invita a tus innovadores y forma una comunidad próspera aquí mismo .",
  "ContactUsToRequestHubInvite": "Contáctanos para solicitar una invitación al Hub.",
  "WayFindThankYou": "Encontraré mi propio camino, muchas gracias.",
  "*required": "*requerido"
}
